import { useContext, useReducer } from "react";
import ReviewersContext from "./ReviewersContext";
import { reviewersReducer } from "./reviewersReducer";
import { reviewersInitialState } from "./reviewersInitialState";
import { Outlet } from "react-router-dom";


export const useReviewersContext = () => useContext(ReviewersContext)


export function ReviewersProvider() {
    const [reviewersState, reviewersDispatch] = useReducer(
        reviewersReducer,
        reviewersInitialState
    )

    return (
        <ReviewersContext.Provider value={{ reviewersState, reviewersDispatch }}>
            <Outlet />
        </ReviewersContext.Provider>
    )
}
